export const CHECK_IS_LOGGED = "CHECK_IS_LOGGED";
export const SET_EMAIL_VALUE = "SET_EMAIL_VALUE";
export const SET_PASSWORD_VALUE = "SET_PASSWORD_VALUE";
export const SET_VERIFY_PASSWORD_VALUE = "SET_VERIFY_PASSWORD_VALUE";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const LOGIN = "LOGIN";
export const SAVE_USER = "SAVE_USER";
export const SAVE_USER_ID = "SAVE_USER_ID";
export const REGISTER = "REGISTER";
export const REGISTER_EMAIL = "REGISTER_EMAIL";
export const SAVE_USER_TYPE = "SAVE_USER_TYPE";
export const SET_SUCCESS_MESSAGE = "SET_SUCCESS_MESSAGE";
export const LOGOUT = "LOGOUT";
export const SET_REDIRECTION = "SET_REDIRECTION";
export const SET_PHONE_VALUE = "SET_PHONE_VALUE";
export const SET_CITY_VALUE = "SET_CITY_VALUE";
export const SET_CP_VALUE = "SET_CP_VALUE";
export const SET_ADDRESS_VALUE = "SET_ADDRESS_VALUE";
export const SET_NEW_PASSWORD_VALUE = "SET_NEW_PASSWORD_VALUE";
export const UPDATE_USER_INFOS = "UPDATE_USER_INFOS";
export const GET_SOUSCRIPTION = "GET_SOUSCRIPTION";
export const SET_SOUSCRIPTION = "SET_SOUSCRIPTION";
export const SET_IS_LOADING_SOUSCRIPTION = "SET_IS_LOADING_SOUSCRIPTION";
export const SET_RESET_USER_INFOS = "SET_RESET_USER_INFOS";
export const SET_SOCIETE = "SET_SOCIETE";
export const GET_SOCIETE = "GET_SOCIETE";


export const login = () => ({
    type: LOGIN,
});
export const register = () => ({
    type: REGISTER,
});

export const saveUser = (dataUser) => ({
    type: SAVE_USER,
    dataUser
});

export const saveUserId = (idUser) => ({
    type: SAVE_USER_ID,
    idUser
});

export const setEmailValue = (value) => ({
    type: SET_EMAIL_VALUE,
    value,
});

export const setPasswordValue = (value) => ({
    type: SET_PASSWORD_VALUE,
    value,
});

export const setNewPasswordValue = (value) => ({
    type: SET_NEW_PASSWORD_VALUE,
    value
});

export const setVerifyPasswordValue = (value) => ({
    type: SET_VERIFY_PASSWORD_VALUE,
    value,
});

export const setErrorMessage = (msg) => ({
    type: SET_ERROR_MESSAGE,
    msg
});

export const setSuccessMessage = (msg) => ({
    type: SET_SUCCESS_MESSAGE,
    msg
});

export const saveUserType = (userType) => ({
    type: SAVE_USER_TYPE,
    userType
});


export const checkIsLogged = () => ({
    type: CHECK_IS_LOGGED,
});

export const logout = () => ({
    type: LOGOUT
});

export const setRedirection = (bool) => ({
    type: SET_REDIRECTION,
    bool
});
export const setCityValue = (value) => ({
    type: SET_CITY_VALUE,
    value
});
export const setCPValue = (value) => ({
    type: SET_CP_VALUE,
    value
});
export const setAddressValue = (value) => ({
    type: SET_ADDRESS_VALUE,
    value
});
export const setPhoneValue = (value) => ({
    type: SET_PHONE_VALUE,
    value
});
export const updateUserInfos = () => ({
    type: UPDATE_USER_INFOS
});
export const getSouscription = () => ({
    type: GET_SOUSCRIPTION
});
export const setSouscription = (bool) => ({
    type: SET_SOUSCRIPTION,
    bool
});

export const setResetUserInfos = (bool) => ({
    type: SET_RESET_USER_INFOS,
    bool
});

export const setSociete = (data) => ({
    type: SET_SOCIETE,
    data
});
export const getSociete = (data) => ({
    type: GET_SOCIETE,
    data
});






